<template>
  <b-row v-if="parentPath && path" style="height:100%;">
    <b-col md="12" style="height:100%;">
      <b-card
        v-tooltip="uniToolTipTranslation('S430', 'en-US')"
        class="card-panel"
        :header="uniTranslation('S430')"
        style="height:100%; margin-bottom: 0px !important;"
      >
        <RefrigerantPicker :path="path"></RefrigerantPicker>

        <UnidataEditor :parent-path="path" :name="'.flow'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.evaporatingTemperature'"></UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.recirculationRatio'"></UnidataEditor>

        <!-- <unidata-editor :parentPath="path"
            :name="'.condensingTemperature'"></unidata-editor>
          
          <unidata-editor
            :parentPath="path"
            :name="'.overHeating'"></unidata-editor>

          <unidata-editor
            :parentPath="path"
            :name="'.subcooling'"></unidata-editor> -->

        <UnidataEditorCorrelator :parent-path="path" group="PressureGroup">
        </UnidataEditorCorrelator>

        <UnidataEditor :parent-path="path" :name="'.foulingFactor'"></UnidataEditor>

        <UnidataEditorCorrelator :parent-path="path" group="FluidVelocity">
        </UnidataEditorCorrelator>

        <!-- 
                    <unidata-editor :parentPath="path"
            :name="'.fluidVelocityGasPhase'"></unidata-editor>

          <unidata-editor-correlator :parentPath="path" group="EvaporatingGroup">
            </unidata-editor-correlator>

          <unidata-editor-correlator :parentPath="path" group="CondensingGroup">
            </unidata-editor-correlator> 

          <div>
            <unidata-editor
              :parentPath="path"
              :name="'.inletValvePressure'"></unidata-editor>
          </div> 

          <unidata-editor-correlator :parentPath="path" group="PressureGroup">
              </unidata-editor-correlator>
          -->
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import RefrigerantPicker from "../shared/RefrigerantPicker";
import UnidataEditor from "../unidata/UnidataEditor";
import UnidataEditorCorrelator from "../unidata/UnidataEditorCorrelator";
// import jsonHelper from "../../shared/jsonHelper";
import { mapGetters } from "vuex";
// import fluidService from "../../services/backend/fluidService";

export default {
  components: {
    RefrigerantPicker,
    UnidataEditor,
    UnidataEditorCorrelator
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"])
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    }
  },
  mounted: function() {
    if (this.parentPath && this.localPath) {
      this.path = this.parentPath + this.localPath;
    }
  },
  methods: {}
};
</script>

<style lang="scss"></style>
